import { find } from 'lodash-es';
import { IVariant, TOptionName, TUserSelection } from '../../types/PDP';
import { computeQuantityRemaining } from '../ScarcityMessaging/InitUrgencyMessage';
import { getSizeNumbers } from './helpers';
import { hasHiddenInventoryTag } from 'src/scripts/utils/plp-pdp-shared';
import { checkIfItemCanBeSoldOut } from 'src/scripts/utils/helpers';

export const OPEN_VARIANT_SELECTOR = 'open-variant-selector';
export const dispatchOpenVariantSelectorDropdownEvent = (productIndex?: number) =>
  document.dispatchEvent(new CustomEvent(OPEN_VARIANT_SELECTOR, { detail: productIndex ? productIndex : 0 }));

export const getSizeSelectorItems = (
  optionName: TOptionName,
  optionValues: string[],
  variants: IVariant[],
  tags: string[] | undefined,
  productType: string,
  productUserSelection: TUserSelection
) => {
  const isVariantPresentWithOption = (optionValue: string) => {
    const variant = find(variants, {
      selectionOptions: { [optionName]: optionValue, Color: productUserSelection.Color },
    });
    return variant ? true : false;
  };

  const validatedOptionValues = optionValues.filter((optionValue) => isVariantPresentWithOption(optionValue));

  const sizeSelectorItems = validatedOptionValues.map((optionValue, optionIndex) => {
    let variant = find(variants, {
      selectionOptions: { [optionName]: optionValue, Color: productUserSelection.Color },
    });

    let isPhasedOutProduct = tags ? checkIfProductIsPhasedOut(tags) : false;

    let shouldHideInventory = tags ? hasHiddenInventoryTag(tags) : false;

    let availableForSale = variant && variant.availableForSale;

    let unlimitedInventory = !checkIfItemCanBeSoldOut(tags);

    const sku = variant ? variant.sku : '';
    let sizeMappedInfo = getSizeNumbers(optionValue, productType, sku);

    let quantityXLeft = computeQuantityRemaining(variant);
    let isActive = productUserSelection[optionName] === optionValue;

    return {
      optionValue,
      variant,
      isPhasedOutProduct,
      availableForSale,
      shouldHideInventory,
      sizeMappedInfo,
      quantityXLeft,
      optionIndex,
      isActive,
      unlimitedInventory,
    };
  });
  return sizeSelectorItems;
};

export const checkIfProductIsPhasedOut = (tags: string[]) => {
  return tags.some((item) => item.toLowerCase() === 'status:phaseout' || item.toLowerCase() === 'status:xphaseout');
};
